<template>
    <div class="search-input" ref="root">
        <p v-if="label" class="label">{{ label }}</p>

        <div class="input-wrapper" :class="{ open: isOpen, error: isError }" ref="wrapper">
            <input type="text" class="input" :placeholder="placeholder" v-model="query" @input="onInput"
                @focus="openDropdown" />

            <div class="spinner" v-if="loading"></div>
        </div>

        <Teleport to="body">
            <div
                ref="dropdown"
                class="search-input-dropdown"
                v-if="isOpen"
                :style="dropdownStyle"
                :class="{ 'open-up': openUp }"
            >
                <div v-if="results.type === 'users'">
                    <div class="dropdown-item" v-for="item in results.data" :key="item.value" @click="selectItem(item)">
                        <p>{{ item.label }}</p>
                        <span>{{ item.login }}</span>
                    </div>
                </div>

                <div class="dropdown-item no-results" v-if="!loading && results.data.length === 0">
                    Нет результатов
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script>
export default {
    name: "SearchInput",

    props: {
        label: String,
        placeholder: {
            type: String,
            default: "Поиск..."
        },

        // Функция для запроса на бэкенд
        // async (query) => { type: 'users',
        // data: [{label, value}]}
        fetchFunction: {
            type: Function,
            required: true
        },

        isError: Boolean,
        openUp: {
            type: Boolean,
            default: false
        }
    },

    emits: ["select"],

    data() {
        return {
            query: "",
            results: { type: 'users', data: [] },
            loading: false,
            timer: null,
            isOpen: false,
            dropdownStyle: {}
        };
    },

    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },

    unmounted() {
        document.removeEventListener("click", this.handleClickOutside);
    },

    methods: {
        updateDropdownPosition() {
            const wrapper = this.$refs.wrapper;
            if (!wrapper) return;
            const rect = wrapper.getBoundingClientRect();
            if (this.openUp) {
                this.dropdownStyle = {
                    position: 'fixed',
                    left: rect.left + 'px',
                    width: rect.width + 'px',
                    bottom: (window.innerHeight - rect.top + 4) + 'px',
                    top: 'auto',
                    zIndex: 10001
                };
            } else {
                this.dropdownStyle = {
                    position: 'fixed',
                    left: rect.left + 'px',
                    top: (rect.bottom + 4) + 'px',
                    width: rect.width + 'px',
                    zIndex: 10001
                };
            }
        },
        onInput() {
            clearTimeout(this.timer);
            this.loading = true;

            // ждём 1 сек → отправляем запрос
            this.timer = setTimeout(() => {
                this.performSearch();
            }, 1000);
        },

        async performSearch() {
            if (!this.query.trim()) {
                this.results = { type: 'users', data: [] };
                this.loading = false;
                return;
            }

            try {
                this.results = await this.fetchFunction(this.query);
            } catch (e) {
                console.error("Search error:", e);
                this.results = { type: 'users', data: [] };
            }

            this.loading = false;
            this.openDropdown();
        },

        selectItem(item) {
            this.query = item.label;
            this.$emit("select", item);
            this.closeDropdown();
        },

        openDropdown() {
            this.updateDropdownPosition();
            this.isOpen = true;
        },

        closeDropdown() {
            this.isOpen = false;
        },

        handleClickOutside(e) {
            const dropdownEl = this.$refs.dropdown;
            if (
                !this.$refs.root.contains(e.target) &&
                !(dropdownEl && dropdownEl.contains(e.target))
            ) {
                this.closeDropdown();
            }
        }
    }
};
</script>

<style scoped lang="scss">
.search-input {
    width: 100%;

    .label {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 5px;
        color: var(--color-text);
    }
}

.input-wrapper {
    position: relative;
    border: 1px solid var(--color-border);
    border-radius: 5px;
    background: var(--color-input-bg);
    //padding: 6px 8px;
    display: flex;
    align-items: center;
    max-width: 250px;

    &.open {
        border-color: var(--color-input-focus);
        box-shadow: 0 0 6px var(--color-input-focus);
    }

    &.error {
        box-shadow: 0 0 6px var(--color-input-error);
    }
}

.input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 14px;
    background: transparent;
    color: var(--color-input-text);
}

.spinner {
    width: 16px;
    height: 16px;
    border: 2px solid var(--color-border);
    border-top-color: var(--color-blue);
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

</style>

<style lang="scss">
.search-input-dropdown {
    background: var(--color-bg);
    border: 1px solid var(--color-border);
    border-radius: 6px;
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 4px;

    .dropdown-item {
        padding: 6px 16px;
        border-radius: 4px;
        cursor: pointer;
        transition: 0.2s background;

        p {
            margin: 0;
        }

        span {
            font-size: 12px;
            color: var(--color-text-light);
        }

        &:hover {
            background: var(--color-bg-hover, rgba(0, 0, 0, 0.05));
        }

        &.no-results {
            text-align: center;
            color: var(--color-text-light);
            cursor: default;

            &:hover {
                background: none;
            }
        }
    }
}
</style>
